import { Environment } from '@npm-client-frontends/shared-utils/environment'

export const env: Environment = {
  awsRegion: 'us-east-1',
  userPoolId: process.env.VITE_FE_USER_POOL_ID,
  userPoolWebClientId: process.env.VITE_FE_USER_POOL_WEB_CLIENT_ID,
  identityPoolId: process.env.VITE_FE_IDENTITY_POOL_ID,
  pinpointAppId: process.env.VITE_FE_PINPOINT_APP_ID,
  allowCollectAnalytics: process.env.VITE_FE_ALLOW_COLLECT_ANALYTICS === 'true',
}
